const SAVE_MFA_OPTION = "[session][mfa]save.option"
const SAVE_MFA_REQUIRED = "[session][mfa]save.rquired"

export {SAVE_MFA_OPTION, SAVE_MFA_REQUIRED}